export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
export const FIELD_CLIMATE_API_ENDPOINT = import.meta.env.VITE_FIELD_CLIMATE_API_ENDPOINT;
export const METEOSTAT_KEY = import.meta.env.VITE_METEOSTAT_KEY;
export const EKOPLAN_API_ENDPOINT = import.meta.env.VITE_EKOPLAN_API_ENDPOINT;
